import { DELETE, GET, POST, PATCH } from "../API";


export const getKeysAPICall = (
    projectId,
    page,
    itemsPerPage,
    onSuccess,
    onError,
    dateFilters = null,
    productSlug = "api",
    status = "active"
) => {
    const params = new URLSearchParams();
    if (page) params.append('page', page);
    if (itemsPerPage) params.append('items_per_page', itemsPerPage);
    params.append('product_slug', productSlug);
    if (status && status !== "active") params.append('status', status);

    if(dateFilters){
        if(dateFilters.start_date) params.append('start_date', dateFilters.start_date);
        if(dateFilters.end_date) params.append('end_date', dateFilters.end_date);
        if(dateFilters.sort_by) params.append('sort_by', dateFilters.sort_by);
        if(dateFilters.ascending !== undefined) params.append('ascending', dateFilters.ascending);
    }

    const url = process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/api_keys${params.toString() ? '?' + params.toString() : ''}`;
    GET(url, onSuccess, onError);
};

export const getUsageBreakdownAPICall = (
    projectId,
    page,
    itemsPerPage,
    onSuccess,
    onError,
    dateFilters = null,
    productSlug = "api"
) => {
    const params = new URLSearchParams();
    if (page) params.append('page', page);
    if (itemsPerPage) params.append('per_page', itemsPerPage); 

    if(dateFilters){
        if(dateFilters.start_date) params.append('start_date', dateFilters.start_date);
        if(dateFilters.end_date) params.append('end_date', dateFilters.end_date);
    }

    const url = process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/usage/${productSlug}/breakdown${params.toString() ? '?' + params.toString() : ''}`;
    GET(url, onSuccess, onError);
};

export const createKeyAPICall = (
    name, 
    details,     
    projectId, 
    onSuccess, 
    onError,
    productSlug = "api"
) => {
    const url = process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/create_api_key`;
    const body = { name, details, product_slug: productSlug };
    POST(url, body, onSuccess, onError);
};

export const updateKeyAPICall = (
    projectId,
    keyId,
    name,
    onSuccess,
    onError,
    details
) => {
    const data = {
        name: name,
        ...(details !== undefined && { details })
    };

    PATCH(
        process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/update_api_key/${keyId}`,
        data,
        onSuccess,
        onError
    );
};

export const deleteKeyAPICall = (
    projectId,
    keyId,
    onSuccess,
    onError
) => {

    DELETE(
        process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/remove_api_key/${keyId}`,
        onSuccess,
        onError
    );
};

// ============= EMBED KEY API CALLS =============

export const getEmbedKeysAPICall = (
    projectId,
    page,
    itemsPerPage,
    onSuccess,
    onError
) => {
    const params = new URLSearchParams();
    params.append('product_slug', 'website_translation');
    if (page) params.append('page', page);
    if (itemsPerPage) params.append('items_per_page', itemsPerPage);

    const url = process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/api_keys?${params.toString()}`;

    GET(
        url,
        onSuccess,
        onError
    );
};


export const createEmbedKeyAPICall = (
    projectId,
    name,
    allowedDomains,
    allowedLanguages,
    onSuccess,
    onError
) => {
    const data = {
        name: name,
        product_slug: 'website_translation',
        allowed_domains: allowedDomains,
        allowed_languages: allowedLanguages || []
    };

    POST(
        process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/create_api_key`,
        data,
        onSuccess,
        onError
    );
};

export const updateEmbedKeyAPICall = (
    projectId,
    keyId,
    name,
    allowedDomains,
    allowedLanguages,
    onSuccess,
    onError
) => {
    const data = {
        name: name,
        allowed_domains: allowedDomains,
        allowed_languages: allowedLanguages || []
    };

    PATCH(
        process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/update_api_key/${keyId}`,
        data,
        onSuccess,
        onError
    );
};

export const deleteEmbedKeyAPICall = (
    projectId,
    keyId,
    onSuccess,
    onError
) => {
    DELETE(
        process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/remove_api_key/${keyId}`,
        onSuccess,
        onError
    );
};

// Get available translation languages
export const getTranslationLanguagesAPICall = (
    onSuccess,
    onError
) => {
    GET(
        process.env.REACT_APP_API_PATH + `/identity/users/translation_languages`,
        onSuccess,
        onError
    );
};